import { render } from "./CreateSongsData.vue?vue&type=template&id=43059a53&scoped=true"
import script from "./CreateSongsData.vue?vue&type=script&lang=ts"
export * from "./CreateSongsData.vue?vue&type=script&lang=ts"

import "./CreateSongsData.vue?vue&type=style&index=0&id=43059a53&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-43059a53"

export default script